import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Flickity from 'flickity';

export default (el, props) => {
    const dom = $(el);
    let flkty;

    const onBreakpoint = e => {
        const current = e.detail.current.size;
        const old = e.detail.old.size;

        // if (current < 750 && old >= 750) {
        //
        // } else if (current >= 750 && old < 750) {
        //
        // }
    }
    const init = () => {
        flkty = new Flickity(el, {
            cellSelector: '[data-slide]',
            wrapAround: false,
            contain: true,
            pageDots: true,
            prevNextButtons: false,
            draggable: false,
            dragThreshold: 10,
            cellAlign: 'center',
            setGallerySize: true,
            percentPosition: true,
            accessibility: true,
            groupCells: true
        });

        window.foobar = flkty;

        Viewport.on('breakpoint', onBreakpoint);
    };

    const destroy = () => {
        flkty.destroy();
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Accessories.js